import * as React from "react";
import TransactionPeriodList from "./TransactionGrid";
import CurrentTransactions from "./CurrentTransactions";
import { useEffect } from "react";
import { initializeTransactionPeriods } from "services/transactionPeriodService";

const TransactionPeriod = () => {
  useEffect(() => {
    initializeTransactionPeriods();
  }, []);
  return (
    <div className="page pt-0">
      <div className="pt-4">
        <CurrentTransactions />
      </div>
      <div className="container">
        <TransactionPeriodList />
      </div>
    </div>
  );
};

export default TransactionPeriod;
